import { render, staticRenderFns } from "./FieldRelated.vue?vue&type=template&id=753ac947"
import script from "./FieldRelated.vue?vue&type=script&lang=js"
export * from "./FieldRelated.vue?vue&type=script&lang=js"
import style0 from "./FieldRelated.vue?vue&type=style&index=0&id=753ac947&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports